import { Theme } from '@mui/material'

import useSharedStyles from '../../utils/shared.styles'

const classes = {
  mainContainer: {
    flexDirection: 'column',
    marginY: 2,
    gap: 2,
  },
  headerRow: {
    gap: '10px',
    justifyContent: 'space-between',
  },
  deviceCount: {
    fontWeight: '500',
  },
  footerButtonsContainer: (hasActivatedDevices: boolean) => ({
    width: { xs: '100%', sm: '350px' },
    justifyContent: hasActivatedDevices ? 'space-between' : 'center',
    paddingX: 2,
    margin: '0 auto',
  }),
  helpDialogText: {
    textAlign: 'left',
    width: '100%',
  },
  listItem: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  listItemButton: {
    ...useSharedStyles.fullWidthContainer,
    paddingY: 2,
  },
  listItemIcon: {
    justifyContent: 'flex-end',
  },
  divider: {
    width: '100%',
  },
  footer: (theme: Theme) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    padding: '16px 0 40px 0',
    width: '100%',
    backgroundColor: theme.palette.common.white,
  }),
  finalizeDialogActions: {
    justifyContent: 'space-between',
    paddingLeft: 2,
  },
  contactLink: {
    fontWeight: '500',
  },
  notFoundItem: (theme: Theme) => ({
    marginTop: theme.spacing(2),
  }),
  notFoundText: {
    textAlign: 'center',
  },
  locateCodeButton: {
    p: 0,
    minWidth: 'auto',
    textTransform: 'none',
    verticalAlign: 'baseline',
  },
  locateCodeImagesRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    mt: 2,
  },
  locateCodeImagesRowCentered: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    mt: 2,
  },
  locateCodeSvgWrapper: {
    height: 72,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
  locateCodeSvgImg: {
    display: 'block',
    transform: 'translateX(-12px)',
  } as React.CSSProperties,
}

export default classes
